import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

declare const grecaptcha: any;

@Injectable({
  providedIn: 'root'
})
export class RecaptchaService {

  executeAction(action: string): Promise<string> {
    return new Promise((resolve, reject) => {
      grecaptcha.ready(() => {
        grecaptcha.execute(environment.reCaptchaSiteKey, { action }).then(
          (token: string) => resolve(token),
          (error: any) => reject(error instanceof Error ? error : new Error(String(error)))
        );
      });
    });
  }
}
